import { useFacturasStore } from '../stores/useFacturasStore';

/**
 * Tras createFactura/updateFactura, el store devuelve null si handleStoreAction capturó el error.
 * Lanza con mensaje legible; 403/RLS → texto orientativo para aplicar migración Supabase.
 */
export function throwIfFacturaMutationFailed(result: unknown, operation: 'crear' | 'actualizar'): void {
  if (result != null) return;
  const msg = useFacturasStore.getState().error || '';
  const lower = msg.toLowerCase();
  if (
    lower.includes('403') ||
    lower.includes('42501') ||
    lower.includes('permission denied') ||
    lower.includes('rls') ||
    lower.includes('row-level security') ||
    lower.includes('violates row-level security') ||
    lower.includes('new row violates')
  ) {
    throw new Error(
      'No tienes permiso para guardar esta factura (política de seguridad en la base de datos). ' +
        'Ejecuta en Supabase la migración «20260326140000_fix_facturas_rls_uid_email_compat.sql» ' +
        'o pide a un administrador que la aplique. Si el problema sigue, revisa que tu usuario esté vinculado a la empresa.'
    );
  }
  throw new Error(
    msg ||
      (operation === 'crear' ? 'No se pudo crear la factura.' : 'No se pudo actualizar la factura.')
  );
}
